import { render, staticRenderFns } from "./ListCustomerSegment.vue?vue&type=template&id=45aa1e83"
import script from "./ListCustomerSegment.vue?vue&type=script&lang=js"
export * from "./ListCustomerSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports